import type { MappingReadinessReason } from "../../api/mappingReadiness";

type AiInsightWaitingReason = MappingReadinessReason | "no_data" | null | undefined;

export function AiInsightWaitingState({ reason }: { reason?: AiInsightWaitingReason } = {}) {
  const message =
    reason === "document_processing"
      ? "Waiting for document processing to complete before generating insights."
      : reason === "no_data"
        ? "No deal data is available yet, so insights cannot be generated."
        : "Waiting for mapping validation to complete before generating insights.";
  return (
    <section className="global-insights-overlay__section" aria-live="polite">
      <p className="global-insights-overlay__raid-status-text">{message}</p>
    </section>
  );
}
